module.exports = __webpack_public_path__ + "zvetseni-prsou_15_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-prsou_15_after_tn.jpg
// module id = 1771
// module chunks = 0